import React from 'react';

import BookingInquiryHistoryIcon from '@assets/img/icons/bookinginquiry-history.svg';
import currentBookingsIcon from '@assets/img/icons/current-bookings.svg';
import pastBookingsIcon from '@assets/img/icons/past-bookings.svg';
import { Navigation } from '@components/Navigation';
import { bookingsStrings } from '@data/bookings';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      padding: '1rem 1rem',
    },
    backgroundColor: theme.palette.background.paper,
    flex: 1,
  },
  inner: {
    ...common.flexColumn,
    maxWidth: '1600px',
    padding: '1rem 1rem',
    margin: '0 auto',
  },
  contents: {
    ...common.flexInline,
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumn,
    },
  },
  innerContent: {
    ...common.flexColumn,
    flex: 1,
    padding: '1rem 2rem',
    overflow: 'hidden',
    rowGap: '1rem',
  },
}));

export const BookingsContainer: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { children } = props;
  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        <div className={classes.contents}>
          <Navigation
            baseUrl="/utilities/Bookings"
            routes={[
              {
                name: 'BookingInquiryHistory',
                icon: <img src={BookingInquiryHistoryIcon} height={16} width={16} />,
                label: bookingsStrings.bookingInquiryHistory,
              },
              {
                name: 'CurrentBookings',
                icon: <img src={currentBookingsIcon} height={16} width={16} />,
                label: bookingsStrings.currentBookings,
              },
              {
                name: 'PastBookings',
                icon: <img src={pastBookingsIcon} height={16} width={16} />,
                label: bookingsStrings.pastBookings,
              },
            ]}
          />

          <div className={classes.innerContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};
